export const LOANS_STATUSES = {
  activeInPayment: 'active_in_payment',
  activePaid: 'active_paid',
  inProgress: 'in_progress',
  inactive: 'inactive',
  indefinitelyOnHold: 'indefinitely_on_hold',
};
